var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartFeatureIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5416 0.791616H32.4583C45.575 0.791616 56.2083 11.4246 56.2083 24.5416V32.4583C56.2083 45.5748 45.575 56.2082 32.4583 56.2082H24.5416C11.4249 56.2082 0.791673 45.5748 0.791673 32.4583V24.5416C0.791673 11.4246 11.4249 0.791616 24.5416 0.791616Z",
    fill: "url(#paint0_linear_1_482)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.217 32.9625C31.3848 32.7923 31.4688 32.5914 31.4688 32.359V30.2147H40.3749V36.648C40.3749 37.2371 40.1674 37.7423 39.752 38.162C39.3368 38.5821 38.8375 38.7919 38.2545 38.7919H18.7455C18.1624 38.7919 17.6631 38.5821 17.2479 38.162C16.8325 37.7423 16.6249 37.2371 16.6249 36.648V30.2147H25.5311V32.359C25.5311 32.5914 25.6151 32.7923 25.783 32.9625C25.9509 33.1319 26.1497 33.2171 26.3795 33.2171H30.6206C30.8502 33.2171 31.0492 33.1319 31.217 32.9625ZM30.1966 30.2147H26.8034V31.93H30.1966V30.2147ZM39.752 22.2674C39.3368 21.8469 38.8375 21.637 38.2545 21.637H33.5891V19.4927C33.5891 19.1352 33.4656 18.8317 33.2181 18.581C32.9709 18.3316 32.6703 18.2061 32.317 18.2061H24.6831C24.3296 18.2061 24.0293 18.3316 23.7819 18.581C23.5345 18.8313 23.4108 19.1352 23.4108 19.4927V21.637H18.7456C18.1624 21.637 17.6631 21.8469 17.2479 22.2674C16.8325 22.6866 16.6249 23.1914 16.6249 23.7813V28.928H40.3749V23.7813C40.3749 23.1914 40.1674 22.6866 39.752 22.2674ZM31.8929 21.637H25.1072V19.9213H31.8929V21.637Z",
    fill: "#FF4550"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_482",
    x1: 32.7855,
    y1: 89.7855,
    x2: 89.7855,
    y2: 24.2145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF416C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4B2B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartFeatureIcon2);
export default __webpack_public_path__ + "static/media/smart-feature-icon-2.0d9d63e717bd3a232bed6dc5e4106125.svg";
export { ForwardRef as ReactComponent };